export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute()
  const routeName = computed(() => route.name?.toString() ?? '')

  const setupHead = () => {
    const {
      linksCanonicalAndAlternate,
      linksCanonicalAndAlternatePrivatevillapreview,
    } = useSeoLinks()

    const links = computed(() => {
      const privatevillapreviewPage = routeName.value.includes(
        'screenshot-whitebrand',
      )
      const disableLinks = routeName.value.includes('stayProposal-token')

      if (privatevillapreviewPage) {
        return linksCanonicalAndAlternatePrivatevillapreview.value
      }

      if (disableLinks) return []

      return linksCanonicalAndAlternate.value
    })

    useHead({
      link: [...links.value],
    })
  }

  // for server rendering
  nuxtApp.hook('app:rendered', setupHead)
  // for client rendering
  nuxtApp.hook('page:finish', setupHead)
})
